export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/car-c4204ecfa7a2e55dbde351359d082d45.png";